import { render, staticRenderFns } from "./RobotData.vue?vue&type=template&id=728374dc&scoped=true"
import script from "./RobotData.vue?vue&type=script&lang=js"
export * from "./RobotData.vue?vue&type=script&lang=js"
import style0 from "./RobotData.vue?vue&type=style&index=0&id=728374dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728374dc",
  null
  
)

export default component.exports